module.exports = __webpack_public_path__ + "img/logo.75509f2e.png";